export const extractTableHeaders = (obj) => {
    console.log('✌️obj --->', obj);
    return Object.keys(obj).map(key => ({
        name: key.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase()), // Format name
        field: key
    }));
};

export function extractAxisLabels(data) {
    // Use Sets to collect unique values
    const uniqueYValues = new Set();
    const uniqueXValues = new Set();

    // Populate the sets with values from the data
    data.forEach(item => {
        if (item.y) uniqueYValues.add(item.y);
        if (item.x) uniqueXValues.add(item.x);
    });

    // Convert Sets to arrays
    const yValues = Array.from(uniqueYValues);
    const xValues = Array.from(uniqueXValues);

    // Create objects in the same format as your examples
    return {
        yAxisLabels: {
            label: 'Products',
            values: yValues
        },
        xAxisLabels: {
            label: 'Companies',
            values: xValues
        }
    };
}

export function getUniqueXY(data) {
    const xSet = new Set();
    const ySet = new Set();

    data.forEach(item => {
        if (item.x) xSet.add(item.x);
        if (item.y) ySet.add(item.y);
    });

    const uniqueX = Array.from(xSet);
    const uniqueY = Array.from(ySet);

    return { uniqueX, uniqueY };
}
